/**
 * Generated by orval v8.4.0 🍺
 * Do not edit manually.
 * Organization API
 * REST API сервиса **organization-api** — управление организационной
структурой (Organization, LegalEntity, привязка Business/Network),
доступом (OrganizationMembership/Access Scope), audit-логом и
справочником специализаций (канон + local mapping, DEV-5759).

Покрывает спеки 001–007, 010–019 (см. `specs/`).

## Переходная модель

Organization внедряется без обязательной миграции существующих клиентов:
Business и Network могут продолжать работать без Organization
(`organization_id = NULL`). Привязка — только ручная операция
администратора, без авто-объединения. Подробности инвариантов —
см. `specs/003-business-network-organization-linking.md`.

## Специализации (DEV-5759)

Глобальный справочник = unique `theme` + `countryCode` (`SpecializationCatalog` /
значения `Specialization` внутри справочника; `version` растёт при изменении словаря).
Локальные термины МИС — `LocalSpecialization`; сопоставление — proposals/rules
(`specs/017`–`019`).

## Что не покрыто

| Область | Причина |
|---|---|
| Bootstrap сервиса, health-check | `specs/000-organization-service-bootstrap.md` — инфраструктура, не бизнес-API |
| Back Office UI | отдельный будущий поток, backend-only волна |
| Billing Engine, Prepayment, White-label | вне текущей волны (Out of Scope PRD) |
| RBAC-хранилище (legacy ACL/grantGroups corev2) | вне домена organization-api — целевая модель прав уже реализована как OrganizationMembership (`specs/006-organization-membership-access-scope.md`) |
| Outbound Representation / партнёрский фид | вне скоупа inbound mapping |

 * OpenAPI spec version: 1.0.0-draft
 */

import type {
	DataTag,
	DefinedInitialDataOptions,
	DefinedUseQueryResult,
	MutationFunction,
	QueryClient,
	QueryFunction,
	QueryKey,
	UndefinedInitialDataOptions,
	UseMutationOptions,
	UseMutationResult,
	UseQueryOptions,
	UseQueryResult,
} from "@tanstack/react-query"
import { useMutation, useQuery } from "@tanstack/react-query"
import { customFetch } from "../../custom-organization-api-client"
import type {
	BadRequestResponse,
	ConflictResponse,
	DefaultErrorResponse,
	ForbiddenResponse,
	NotFoundResponse,
	Organization,
	OrganizationCreateRequest,
	OrganizationslistOrganizationCountries200,
	OrganizationslistOrganizations200,
	OrganizationslistOrganizationsParams,
	OrganizationsSummary,
	OrganizationUpdateRequest,
	UnauthorizedResponse,
} from ".././types/organization"

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1]

export type HTTPStatusCode1xx = 100 | 101 | 102 | 103
export type HTTPStatusCode2xx = 200 | 201 | 202 | 203 | 204 | 205 | 206 | 207
export type HTTPStatusCode3xx = 300 | 301 | 302 | 303 | 304 | 305 | 307 | 308
export type HTTPStatusCode4xx =
	| 400
	| 401
	| 402
	| 403
	| 404
	| 405
	| 406
	| 407
	| 408
	| 409
	| 410
	| 411
	| 412
	| 413
	| 414
	| 415
	| 416
	| 417
	| 418
	| 419
	| 420
	| 421
	| 422
	| 423
	| 424
	| 426
	| 428
	| 429
	| 431
	| 451
export type HTTPStatusCode5xx = 500 | 501 | 502 | 503 | 504 | 505 | 507 | 511
export type HTTPStatusCodes =
	| HTTPStatusCode1xx
	| HTTPStatusCode2xx
	| HTTPStatusCode3xx
	| HTTPStatusCode4xx
	| HTTPStatusCode5xx

/**
 * Создаёт новую Organization со статусом `ACTIVE`. Organization не
содержит юридических реквизитов (ИНН и т.п.) — они живут в LegalEntity
(см. `POST /organizations/{organizationId}/legal-entities`).

 * @summary Создать Organization
 */
export type OrganizationscreateOrganizationResponse201 = {
	data: Organization
	status: 201
}

export type OrganizationscreateOrganizationResponse400 = {
	data: BadRequestResponse
	status: 400
}

export type OrganizationscreateOrganizationResponse401 = {
	data: UnauthorizedResponse
	status: 401
}

export type OrganizationscreateOrganizationResponse403 = {
	data: ForbiddenResponse
	status: 403
}

export type OrganizationscreateOrganizationResponseDefault = {
	data: DefaultErrorResponse
	status: Exclude<HTTPStatusCodes, 201 | 400 | 401 | 403>
}

export type OrganizationscreateOrganizationResponseSuccess =
	OrganizationscreateOrganizationResponse201 & {
		headers: Headers
	}
export type OrganizationscreateOrganizationResponseError = (
	| OrganizationscreateOrganizationResponse400
	| OrganizationscreateOrganizationResponse401
	| OrganizationscreateOrganizationResponse403
	| OrganizationscreateOrganizationResponseDefault
) & {
	headers: Headers
}

export type OrganizationscreateOrganizationResponse =
	| OrganizationscreateOrganizationResponseSuccess
	| OrganizationscreateOrganizationResponseError

export const getOrganizationscreateOrganizationUrl = () => {
	return `/organizations`
}

export const OrganizationscreateOrganization = async (
	organizationCreateRequest: OrganizationCreateRequest,
	options?: RequestInit,
): Promise<OrganizationscreateOrganizationResponse> => {
	return customFetch<OrganizationscreateOrganizationResponse>(
		getOrganizationscreateOrganizationUrl(),
		{
			...options,
			method: "POST",
			headers: { "Content-Type": "application/json", ...options?.headers },
			body: JSON.stringify(organizationCreateRequest),
		},
	)
}

export const getOrganizationscreateOrganizationMutationOptions = <
	TError =
		| BadRequestResponse
		| UnauthorizedResponse
		| ForbiddenResponse
		| DefaultErrorResponse,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof OrganizationscreateOrganization>>,
		TError,
		{ data: OrganizationCreateRequest },
		TContext
	>
	request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
	Awaited<ReturnType<typeof OrganizationscreateOrganization>>,
	TError,
	{ data: OrganizationCreateRequest },
	TContext
> => {
	const mutationKey = ["organizationscreateOrganization"]
	const { mutation: mutationOptions, request: requestOptions } = options
		? options.mutation &&
			"mutationKey" in options.mutation &&
			options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey }, request: undefined }

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof OrganizationscreateOrganization>>,
		{ data: OrganizationCreateRequest }
	> = (props) => {
		const { data } = props ?? {}

		return OrganizationscreateOrganization(data, requestOptions)
	}

	return { mutationFn, ...mutationOptions }
}

export type OrganizationscreateOrganizationMutationResult = NonNullable<
	Awaited<ReturnType<typeof OrganizationscreateOrganization>>
>
export type OrganizationscreateOrganizationMutationBody =
	OrganizationCreateRequest
export type OrganizationscreateOrganizationMutationError =
	| BadRequestResponse
	| UnauthorizedResponse
	| ForbiddenResponse
	| DefaultErrorResponse

/**
 * @summary Создать Organization
 */
export const useOrganizationscreateOrganization = <
	TError =
		| BadRequestResponse
		| UnauthorizedResponse
		| ForbiddenResponse
		| DefaultErrorResponse,
	TContext = unknown,
>(
	options?: {
		mutation?: UseMutationOptions<
			Awaited<ReturnType<typeof OrganizationscreateOrganization>>,
			TError,
			{ data: OrganizationCreateRequest },
			TContext
		>
		request?: SecondParameter<typeof customFetch>
	},
	queryClient?: QueryClient,
): UseMutationResult<
	Awaited<ReturnType<typeof OrganizationscreateOrganization>>,
	TError,
	{ data: OrganizationCreateRequest },
	TContext
> => {
	return useMutation(
		getOrganizationscreateOrganizationMutationOptions(options),
		queryClient,
	)
}
/**
 * Platform Admin получает все Organization платформы. Любой другой
авторизованный пользователь получает только те, где у него есть хотя
бы одна OrganizationMembership (любой scopeType) — без явного
параметра переключения режима. Авто-скоуп применяется как
обязательное предварительное условие, до фильтров.

 * @summary Список Organization с авто-скоупом по правам
 */
export type OrganizationslistOrganizationsResponse200 = {
	data: OrganizationslistOrganizations200
	status: 200
}

export type OrganizationslistOrganizationsResponse401 = {
	data: UnauthorizedResponse
	status: 401
}

export type OrganizationslistOrganizationsResponseDefault = {
	data: DefaultErrorResponse
	status: Exclude<HTTPStatusCodes, 200 | 401>
}

export type OrganizationslistOrganizationsResponseSuccess =
	OrganizationslistOrganizationsResponse200 & {
		headers: Headers
	}
export type OrganizationslistOrganizationsResponseError = (
	| OrganizationslistOrganizationsResponse401
	| OrganizationslistOrganizationsResponseDefault
) & {
	headers: Headers
}

export type OrganizationslistOrganizationsResponse =
	| OrganizationslistOrganizationsResponseSuccess
	| OrganizationslistOrganizationsResponseError

export const getOrganizationslistOrganizationsUrl = (
	params?: OrganizationslistOrganizationsParams,
) => {
	const normalizedParams = new URLSearchParams()

	Object.entries(params || {}).forEach(([key, value]) => {
		if (value !== undefined) {
			normalizedParams.append(key, value === null ? "null" : value.toString())
		}
	})

	const stringifiedParams = normalizedParams.toString()

	return stringifiedParams.length > 0
		? `/organizations?${stringifiedParams}`
		: `/organizations`
}

export const OrganizationslistOrganizations = async (
	params?: OrganizationslistOrganizationsParams,
	options?: RequestInit,
): Promise<OrganizationslistOrganizationsResponse> => {
	return customFetch<OrganizationslistOrganizationsResponse>(
		getOrganizationslistOrganizationsUrl(params),
		{
			...options,
			method: "GET",
		},
	)
}

export const getOrganizationslistOrganizationsQueryKey = (
	params?: OrganizationslistOrganizationsParams,
) => {
	return [`/organizations`, ...(params ? [params] : [])] as const
}

export const getOrganizationslistOrganizationsQueryOptions = <
	TData = Awaited<ReturnType<typeof OrganizationslistOrganizations>>,
	TError = UnauthorizedResponse | DefaultErrorResponse,
>(
	params?: OrganizationslistOrganizationsParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof OrganizationslistOrganizations>>,
				TError,
				TData
			>
		>
		request?: SecondParameter<typeof customFetch>
	},
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {}

	const queryKey =
		queryOptions?.queryKey ?? getOrganizationslistOrganizationsQueryKey(params)

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof OrganizationslistOrganizations>>
	> = ({ signal }) =>
		OrganizationslistOrganizations(params, { signal, ...requestOptions })

	return {
		queryKey,
		queryFn,
		refetchOnMount: false,
		...queryOptions,
	} as UseQueryOptions<
		Awaited<ReturnType<typeof OrganizationslistOrganizations>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type OrganizationslistOrganizationsQueryResult = NonNullable<
	Awaited<ReturnType<typeof OrganizationslistOrganizations>>
>
export type OrganizationslistOrganizationsQueryError =
	| UnauthorizedResponse
	| DefaultErrorResponse

export function useOrganizationslistOrganizations<
	TData = Awaited<ReturnType<typeof OrganizationslistOrganizations>>,
	TError = UnauthorizedResponse | DefaultErrorResponse,
>(
	params: undefined | OrganizationslistOrganizationsParams,
	options: {
		query: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof OrganizationslistOrganizations>>,
				TError,
				TData
			>
		> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof OrganizationslistOrganizations>>,
					TError,
					Awaited<ReturnType<typeof OrganizationslistOrganizations>>
				>,
				"initialData"
			>
		request?: SecondParameter<typeof customFetch>
	},
	queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}
export function useOrganizationslistOrganizations<
	TData = Awaited<ReturnType<typeof OrganizationslistOrganizations>>,
	TError = UnauthorizedResponse | DefaultErrorResponse,
>(
	params?: OrganizationslistOrganizationsParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof OrganizationslistOrganizations>>,
				TError,
				TData
			>
		> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof OrganizationslistOrganizations>>,
					TError,
					Awaited<ReturnType<typeof OrganizationslistOrganizations>>
				>,
				"initialData"
			>
		request?: SecondParameter<typeof customFetch>
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}
export function useOrganizationslistOrganizations<
	TData = Awaited<ReturnType<typeof OrganizationslistOrganizations>>,
	TError = UnauthorizedResponse | DefaultErrorResponse,
>(
	params?: OrganizationslistOrganizationsParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof OrganizationslistOrganizations>>,
				TError,
				TData
			>
		>
		request?: SecondParameter<typeof customFetch>
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}
/**
 * @summary Список Organization с авто-скоупом по правам
 */

export function useOrganizationslistOrganizations<
	TData = Awaited<ReturnType<typeof OrganizationslistOrganizations>>,
	TError = UnauthorizedResponse | DefaultErrorResponse,
>(
	params?: OrganizationslistOrganizationsParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof OrganizationslistOrganizations>>,
				TError,
				TData
			>
		>
		request?: SecondParameter<typeof customFetch>
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
} {
	const queryOptions = getOrganizationslistOrganizationsQueryOptions(
		params,
		options,
	)

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<
		TData,
		TError
	> & { queryKey: DataTag<QueryKey, TData, TError> }

	return { ...query, queryKey: queryOptions.queryKey }
}

/**
 * Уникальные countryCode среди Organization, доступных вызывающему —
тот же авто-скоуп по правам, что и в `GET /organizations` (Platform
Admin видит страны всех Organization, остальные — только своих).
Organization без countryCode не создают запись `null` в списке.
Источник значений для select-фильтра по стране на списке Organization.

 * @summary Список уникальных стран среди Organization, видимых вызывающему
 */
export type OrganizationslistOrganizationCountriesResponse200 = {
	data: OrganizationslistOrganizationCountries200
	status: 200
}

export type OrganizationslistOrganizationCountriesResponse401 = {
	data: UnauthorizedResponse
	status: 401
}

export type OrganizationslistOrganizationCountriesResponseDefault = {
	data: DefaultErrorResponse
	status: Exclude<HTTPStatusCodes, 200 | 401>
}

export type OrganizationslistOrganizationCountriesResponseSuccess =
	OrganizationslistOrganizationCountriesResponse200 & {
		headers: Headers
	}
export type OrganizationslistOrganizationCountriesResponseError = (
	| OrganizationslistOrganizationCountriesResponse401
	| OrganizationslistOrganizationCountriesResponseDefault
) & {
	headers: Headers
}

export type OrganizationslistOrganizationCountriesResponse =
	| OrganizationslistOrganizationCountriesResponseSuccess
	| OrganizationslistOrganizationCountriesResponseError

export const getOrganizationslistOrganizationCountriesUrl = () => {
	return `/organizations/countries`
}

export const OrganizationslistOrganizationCountries = async (
	options?: RequestInit,
): Promise<OrganizationslistOrganizationCountriesResponse> => {
	return customFetch<OrganizationslistOrganizationCountriesResponse>(
		getOrganizationslistOrganizationCountriesUrl(),
		{
			...options,
			method: "GET",
		},
	)
}

export const getOrganizationslistOrganizationCountriesQueryKey = () => {
	return [`/organizations/countries`] as const
}

export const getOrganizationslistOrganizationCountriesQueryOptions = <
	TData = Awaited<ReturnType<typeof OrganizationslistOrganizationCountries>>,
	TError = UnauthorizedResponse | DefaultErrorResponse,
>(options?: {
	query?: Partial<
		UseQueryOptions<
			Awaited<ReturnType<typeof OrganizationslistOrganizationCountries>>,
			TError,
			TData
		>
	>
	request?: SecondParameter<typeof customFetch>
}) => {
	const { query: queryOptions, request: requestOptions } = options ?? {}

	const queryKey =
		queryOptions?.queryKey ??
		getOrganizationslistOrganizationCountriesQueryKey()

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof OrganizationslistOrganizationCountries>>
	> = ({ signal }) =>
		OrganizationslistOrganizationCountries({ signal, ...requestOptions })

	return {
		queryKey,
		queryFn,
		refetchOnMount: false,
		...queryOptions,
	} as UseQueryOptions<
		Awaited<ReturnType<typeof OrganizationslistOrganizationCountries>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type OrganizationslistOrganizationCountriesQueryResult = NonNullable<
	Awaited<ReturnType<typeof OrganizationslistOrganizationCountries>>
>
export type OrganizationslistOrganizationCountriesQueryError =
	| UnauthorizedResponse
	| DefaultErrorResponse

export function useOrganizationslistOrganizationCountries<
	TData = Awaited<ReturnType<typeof OrganizationslistOrganizationCountries>>,
	TError = UnauthorizedResponse | DefaultErrorResponse,
>(
	options: {
		query: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof OrganizationslistOrganizationCountries>>,
				TError,
				TData
			>
		> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof OrganizationslistOrganizationCountries>>,
					TError,
					Awaited<ReturnType<typeof OrganizationslistOrganizationCountries>>
				>,
				"initialData"
			>
		request?: SecondParameter<typeof customFetch>
	},
	queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}
export function useOrganizationslistOrganizationCountries<
	TData = Awaited<ReturnType<typeof OrganizationslistOrganizationCountries>>,
	TError = UnauthorizedResponse | DefaultErrorResponse,
>(
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof OrganizationslistOrganizationCountries>>,
				TError,
				TData
			>
		> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof OrganizationslistOrganizationCountries>>,
					TError,
					Awaited<ReturnType<typeof OrganizationslistOrganizationCountries>>
				>,
				"initialData"
			>
		request?: SecondParameter<typeof customFetch>
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}
export function useOrganizationslistOrganizationCountries<
	TData = Awaited<ReturnType<typeof OrganizationslistOrganizationCountries>>,
	TError = UnauthorizedResponse | DefaultErrorResponse,
>(
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof OrganizationslistOrganizationCountries>>,
				TError,
				TData
			>
		>
		request?: SecondParameter<typeof customFetch>
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}
/**
 * @summary Список уникальных стран среди Organization, видимых вызывающему
 */

export function useOrganizationslistOrganizationCountries<
	TData = Awaited<ReturnType<typeof OrganizationslistOrganizationCountries>>,
	TError = UnauthorizedResponse | DefaultErrorResponse,
>(
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof OrganizationslistOrganizationCountries>>,
				TError,
				TData
			>
		>
		request?: SecondParameter<typeof customFetch>
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
} {
	const queryOptions =
		getOrganizationslistOrganizationCountriesQueryOptions(options)

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<
		TData,
		TError
	> & { queryKey: DataTag<QueryKey, TData, TError> }

	return { ...query, queryKey: queryOptions.queryKey }
}

/**
 * Агрегат по ВСЕЙ платформе, не по одной странице `GET /organizations`
(spec 014). Только Platform Admin — сводка охватывает данные всех
организаций. Не включает статус синхронизации МИС и другие
показатели вне домена organization-api (Out of Scope).

 * @summary Сводная статистика платформы (Organization/Business/Network)
 */
export type OrganizationsgetOrganizationsSummaryResponse200 = {
	data: OrganizationsSummary
	status: 200
}

export type OrganizationsgetOrganizationsSummaryResponse401 = {
	data: UnauthorizedResponse
	status: 401
}

export type OrganizationsgetOrganizationsSummaryResponse403 = {
	data: ForbiddenResponse
	status: 403
}

export type OrganizationsgetOrganizationsSummaryResponseDefault = {
	data: DefaultErrorResponse
	status: Exclude<HTTPStatusCodes, 200 | 401 | 403>
}

export type OrganizationsgetOrganizationsSummaryResponseSuccess =
	OrganizationsgetOrganizationsSummaryResponse200 & {
		headers: Headers
	}
export type OrganizationsgetOrganizationsSummaryResponseError = (
	| OrganizationsgetOrganizationsSummaryResponse401
	| OrganizationsgetOrganizationsSummaryResponse403
	| OrganizationsgetOrganizationsSummaryResponseDefault
) & {
	headers: Headers
}

export type OrganizationsgetOrganizationsSummaryResponse =
	| OrganizationsgetOrganizationsSummaryResponseSuccess
	| OrganizationsgetOrganizationsSummaryResponseError

export const getOrganizationsgetOrganizationsSummaryUrl = () => {
	return `/organizations/summary`
}

export const OrganizationsgetOrganizationsSummary = async (
	options?: RequestInit,
): Promise<OrganizationsgetOrganizationsSummaryResponse> => {
	return customFetch<OrganizationsgetOrganizationsSummaryResponse>(
		getOrganizationsgetOrganizationsSummaryUrl(),
		{
			...options,
			method: "GET",
		},
	)
}

export const getOrganizationsgetOrganizationsSummaryQueryKey = () => {
	return [`/organizations/summary`] as const
}

export const getOrganizationsgetOrganizationsSummaryQueryOptions = <
	TData = Awaited<ReturnType<typeof OrganizationsgetOrganizationsSummary>>,
	TError = UnauthorizedResponse | ForbiddenResponse | DefaultErrorResponse,
>(options?: {
	query?: Partial<
		UseQueryOptions<
			Awaited<ReturnType<typeof OrganizationsgetOrganizationsSummary>>,
			TError,
			TData
		>
	>
	request?: SecondParameter<typeof customFetch>
}) => {
	const { query: queryOptions, request: requestOptions } = options ?? {}

	const queryKey =
		queryOptions?.queryKey ?? getOrganizationsgetOrganizationsSummaryQueryKey()

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof OrganizationsgetOrganizationsSummary>>
	> = ({ signal }) =>
		OrganizationsgetOrganizationsSummary({ signal, ...requestOptions })

	return {
		queryKey,
		queryFn,
		refetchOnMount: false,
		...queryOptions,
	} as UseQueryOptions<
		Awaited<ReturnType<typeof OrganizationsgetOrganizationsSummary>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type OrganizationsgetOrganizationsSummaryQueryResult = NonNullable<
	Awaited<ReturnType<typeof OrganizationsgetOrganizationsSummary>>
>
export type OrganizationsgetOrganizationsSummaryQueryError =
	| UnauthorizedResponse
	| ForbiddenResponse
	| DefaultErrorResponse

export function useOrganizationsgetOrganizationsSummary<
	TData = Awaited<ReturnType<typeof OrganizationsgetOrganizationsSummary>>,
	TError = UnauthorizedResponse | ForbiddenResponse | DefaultErrorResponse,
>(
	options: {
		query: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof OrganizationsgetOrganizationsSummary>>,
				TError,
				TData
			>
		> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof OrganizationsgetOrganizationsSummary>>,
					TError,
					Awaited<ReturnType<typeof OrganizationsgetOrganizationsSummary>>
				>,
				"initialData"
			>
		request?: SecondParameter<typeof customFetch>
	},
	queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}
export function useOrganizationsgetOrganizationsSummary<
	TData = Awaited<ReturnType<typeof OrganizationsgetOrganizationsSummary>>,
	TError = UnauthorizedResponse | ForbiddenResponse | DefaultErrorResponse,
>(
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof OrganizationsgetOrganizationsSummary>>,
				TError,
				TData
			>
		> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof OrganizationsgetOrganizationsSummary>>,
					TError,
					Awaited<ReturnType<typeof OrganizationsgetOrganizationsSummary>>
				>,
				"initialData"
			>
		request?: SecondParameter<typeof customFetch>
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}
export function useOrganizationsgetOrganizationsSummary<
	TData = Awaited<ReturnType<typeof OrganizationsgetOrganizationsSummary>>,
	TError = UnauthorizedResponse | ForbiddenResponse | DefaultErrorResponse,
>(
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof OrganizationsgetOrganizationsSummary>>,
				TError,
				TData
			>
		>
		request?: SecondParameter<typeof customFetch>
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}
/**
 * @summary Сводная статистика платформы (Organization/Business/Network)
 */

export function useOrganizationsgetOrganizationsSummary<
	TData = Awaited<ReturnType<typeof OrganizationsgetOrganizationsSummary>>,
	TError = UnauthorizedResponse | ForbiddenResponse | DefaultErrorResponse,
>(
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof OrganizationsgetOrganizationsSummary>>,
				TError,
				TData
			>
		>
		request?: SecondParameter<typeof customFetch>
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
} {
	const queryOptions =
		getOrganizationsgetOrganizationsSummaryQueryOptions(options)

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<
		TData,
		TError
	> & { queryKey: DataTag<QueryKey, TData, TError> }

	return { ...query, queryKey: queryOptions.queryKey }
}

/**
 * Частичное обновление: поля, не переданные в теле, не изменяются.
`status` можно менять в обе стороны между `ACTIVE` и `ARCHIVED` —
переход в `ARCHIVED` ведёт себя как `DELETE /organizations/{id}`
(soft delete, `409` при связанных объектах), переход в `ACTIVE`
(восстановление) не требует дополнительных условий.

 * @summary Обновить Organization, включая обратимую архивацию
 */
export type OrganizationsupdateOrganizationResponse200 = {
	data: Organization
	status: 200
}

export type OrganizationsupdateOrganizationResponse400 = {
	data: BadRequestResponse
	status: 400
}

export type OrganizationsupdateOrganizationResponse401 = {
	data: UnauthorizedResponse
	status: 401
}

export type OrganizationsupdateOrganizationResponse403 = {
	data: ForbiddenResponse
	status: 403
}

export type OrganizationsupdateOrganizationResponse404 = {
	data: NotFoundResponse
	status: 404
}

export type OrganizationsupdateOrganizationResponse409 = {
	data: ConflictResponse
	status: 409
}

export type OrganizationsupdateOrganizationResponseDefault = {
	data: DefaultErrorResponse
	status: Exclude<HTTPStatusCodes, 200 | 400 | 401 | 403 | 404 | 409>
}

export type OrganizationsupdateOrganizationResponseSuccess =
	OrganizationsupdateOrganizationResponse200 & {
		headers: Headers
	}
export type OrganizationsupdateOrganizationResponseError = (
	| OrganizationsupdateOrganizationResponse400
	| OrganizationsupdateOrganizationResponse401
	| OrganizationsupdateOrganizationResponse403
	| OrganizationsupdateOrganizationResponse404
	| OrganizationsupdateOrganizationResponse409
	| OrganizationsupdateOrganizationResponseDefault
) & {
	headers: Headers
}

export type OrganizationsupdateOrganizationResponse =
	| OrganizationsupdateOrganizationResponseSuccess
	| OrganizationsupdateOrganizationResponseError

export const getOrganizationsupdateOrganizationUrl = (
	organizationId: string,
) => {
	return `/organizations/${organizationId}`
}

export const OrganizationsupdateOrganization = async (
	organizationId: string,
	organizationUpdateRequest: OrganizationUpdateRequest,
	options?: RequestInit,
): Promise<OrganizationsupdateOrganizationResponse> => {
	return customFetch<OrganizationsupdateOrganizationResponse>(
		getOrganizationsupdateOrganizationUrl(organizationId),
		{
			...options,
			method: "PATCH",
			headers: { "Content-Type": "application/json", ...options?.headers },
			body: JSON.stringify(organizationUpdateRequest),
		},
	)
}

export const getOrganizationsupdateOrganizationMutationOptions = <
	TError =
		| BadRequestResponse
		| UnauthorizedResponse
		| ForbiddenResponse
		| NotFoundResponse
		| ConflictResponse
		| DefaultErrorResponse,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof OrganizationsupdateOrganization>>,
		TError,
		{ organizationId: string; data: OrganizationUpdateRequest },
		TContext
	>
	request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
	Awaited<ReturnType<typeof OrganizationsupdateOrganization>>,
	TError,
	{ organizationId: string; data: OrganizationUpdateRequest },
	TContext
> => {
	const mutationKey = ["organizationsupdateOrganization"]
	const { mutation: mutationOptions, request: requestOptions } = options
		? options.mutation &&
			"mutationKey" in options.mutation &&
			options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey }, request: undefined }

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof OrganizationsupdateOrganization>>,
		{ organizationId: string; data: OrganizationUpdateRequest }
	> = (props) => {
		const { organizationId, data } = props ?? {}

		return OrganizationsupdateOrganization(organizationId, data, requestOptions)
	}

	return { mutationFn, ...mutationOptions }
}

export type OrganizationsupdateOrganizationMutationResult = NonNullable<
	Awaited<ReturnType<typeof OrganizationsupdateOrganization>>
>
export type OrganizationsupdateOrganizationMutationBody =
	OrganizationUpdateRequest
export type OrganizationsupdateOrganizationMutationError =
	| BadRequestResponse
	| UnauthorizedResponse
	| ForbiddenResponse
	| NotFoundResponse
	| ConflictResponse
	| DefaultErrorResponse

/**
 * @summary Обновить Organization, включая обратимую архивацию
 */
export const useOrganizationsupdateOrganization = <
	TError =
		| BadRequestResponse
		| UnauthorizedResponse
		| ForbiddenResponse
		| NotFoundResponse
		| ConflictResponse
		| DefaultErrorResponse,
	TContext = unknown,
>(
	options?: {
		mutation?: UseMutationOptions<
			Awaited<ReturnType<typeof OrganizationsupdateOrganization>>,
			TError,
			{ organizationId: string; data: OrganizationUpdateRequest },
			TContext
		>
		request?: SecondParameter<typeof customFetch>
	},
	queryClient?: QueryClient,
): UseMutationResult<
	Awaited<ReturnType<typeof OrganizationsupdateOrganization>>,
	TError,
	{ organizationId: string; data: OrganizationUpdateRequest },
	TContext
> => {
	return useMutation(
		getOrganizationsupdateOrganizationMutationOptions(options),
		queryClient,
	)
}
/**
 * Organization не удаляется физически. Переводит статус в `ARCHIVED`.
После архивации нельзя создавать/добавлять в неё Network/Business/LegalEntity.
`409` — если операция требует отсутствия связанных объектов, а они есть.
Эквивалентно `PATCH {status: ARCHIVED}`.

 * @summary Архивировать Organization (soft delete)
 */
export type OrganizationsarchiveOrganizationResponse204 = {
	data: void
	status: 204
}

export type OrganizationsarchiveOrganizationResponse401 = {
	data: UnauthorizedResponse
	status: 401
}

export type OrganizationsarchiveOrganizationResponse403 = {
	data: ForbiddenResponse
	status: 403
}

export type OrganizationsarchiveOrganizationResponse404 = {
	data: NotFoundResponse
	status: 404
}

export type OrganizationsarchiveOrganizationResponse409 = {
	data: ConflictResponse
	status: 409
}

export type OrganizationsarchiveOrganizationResponseDefault = {
	data: DefaultErrorResponse
	status: Exclude<HTTPStatusCodes, 204 | 401 | 403 | 404 | 409>
}

export type OrganizationsarchiveOrganizationResponseSuccess =
	OrganizationsarchiveOrganizationResponse204 & {
		headers: Headers
	}
export type OrganizationsarchiveOrganizationResponseError = (
	| OrganizationsarchiveOrganizationResponse401
	| OrganizationsarchiveOrganizationResponse403
	| OrganizationsarchiveOrganizationResponse404
	| OrganizationsarchiveOrganizationResponse409
	| OrganizationsarchiveOrganizationResponseDefault
) & {
	headers: Headers
}

export type OrganizationsarchiveOrganizationResponse =
	| OrganizationsarchiveOrganizationResponseSuccess
	| OrganizationsarchiveOrganizationResponseError

export const getOrganizationsarchiveOrganizationUrl = (
	organizationId: string,
) => {
	return `/organizations/${organizationId}`
}

export const OrganizationsarchiveOrganization = async (
	organizationId: string,
	options?: RequestInit,
): Promise<OrganizationsarchiveOrganizationResponse> => {
	return customFetch<OrganizationsarchiveOrganizationResponse>(
		getOrganizationsarchiveOrganizationUrl(organizationId),
		{
			...options,
			method: "DELETE",
		},
	)
}

export const getOrganizationsarchiveOrganizationMutationOptions = <
	TError =
		| UnauthorizedResponse
		| ForbiddenResponse
		| NotFoundResponse
		| ConflictResponse
		| DefaultErrorResponse,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof OrganizationsarchiveOrganization>>,
		TError,
		{ organizationId: string },
		TContext
	>
	request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
	Awaited<ReturnType<typeof OrganizationsarchiveOrganization>>,
	TError,
	{ organizationId: string },
	TContext
> => {
	const mutationKey = ["organizationsarchiveOrganization"]
	const { mutation: mutationOptions, request: requestOptions } = options
		? options.mutation &&
			"mutationKey" in options.mutation &&
			options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey }, request: undefined }

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof OrganizationsarchiveOrganization>>,
		{ organizationId: string }
	> = (props) => {
		const { organizationId } = props ?? {}

		return OrganizationsarchiveOrganization(organizationId, requestOptions)
	}

	return { mutationFn, ...mutationOptions }
}

export type OrganizationsarchiveOrganizationMutationResult = NonNullable<
	Awaited<ReturnType<typeof OrganizationsarchiveOrganization>>
>

export type OrganizationsarchiveOrganizationMutationError =
	| UnauthorizedResponse
	| ForbiddenResponse
	| NotFoundResponse
	| ConflictResponse
	| DefaultErrorResponse

/**
 * @summary Архивировать Organization (soft delete)
 */
export const useOrganizationsarchiveOrganization = <
	TError =
		| UnauthorizedResponse
		| ForbiddenResponse
		| NotFoundResponse
		| ConflictResponse
		| DefaultErrorResponse,
	TContext = unknown,
>(
	options?: {
		mutation?: UseMutationOptions<
			Awaited<ReturnType<typeof OrganizationsarchiveOrganization>>,
			TError,
			{ organizationId: string },
			TContext
		>
		request?: SecondParameter<typeof customFetch>
	},
	queryClient?: QueryClient,
): UseMutationResult<
	Awaited<ReturnType<typeof OrganizationsarchiveOrganization>>,
	TError,
	{ organizationId: string },
	TContext
> => {
	return useMutation(
		getOrganizationsarchiveOrganizationMutationOptions(options),
		queryClient,
	)
}
